module.exports = __webpack_public_path__ + "static/media/high-school-vr-coding.ab17fc05.jpg";